export const allLanguages = ["en", "de", "it", "fr"] as const;
export type Language = typeof allLanguages[number];
